import { motion } from 'framer-motion';
import styled from 'styled-components';

const Tr = styled(motion.tr).withConfig({
  componentId: "sc-1jk0xho-0"
})(["&:last-child{border-bottom:", ";}&:not(:first-child){border-top:", ";}vertical-align:top;cursor:'auto';", " ", " &[data-selected='true']{border-color:", ";td{background-color:", ";}& + tr{border-top-color:", ";}}"], ({
  theme
}) => theme.components.table.rowBorderBottom, ({
  theme
}) => theme.components.table.rowBorderBottom, ({
  $isDraggable,
  theme
}) => $isDraggable && `
    cursor: grab;

    &:hover {
      background-color: ${theme.components.table.rowHoverColor};
    }
  `, ({
  onClick,
  theme
}) => onClick && `
    cursor: pointer;

    &:hover {
      background-color: ${theme.components.table.rowHoverColor};
    }

    &:active {
      background-color: ${theme.components.table.rowActiveColor};
    }
  `, ({
  theme
}) => theme.components.table.rowSelectionBorderColor, ({
  theme
}) => theme.components.table.rowSelectionColor, ({
  theme
}) => theme.components.table.rowSelectionBorderColor);

export { Tr };
//# sourceMappingURL=Tr.js.map
